/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hours: NonNullable<unknown>, minutes: NonNullable<unknown> }} Station_Work_Countdown_HoursInputs */

const vi_station_work_countdown_hours = /** @type {(inputs: Station_Work_Countdown_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.hours} giờ ${i?.minutes} phút`)
};

/**

* @param {Station_Work_Countdown_HoursInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_countdown_hours = /** @type {((inputs: Station_Work_Countdown_HoursInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Countdown_HoursInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_countdown_hours(inputs)
});